import CrumbTitle from '@/components/crumbTitle/CrumbTitle';
import { DataTable } from '@/components/dataTable';
import { useDataTable } from '@/components/dataTable/hooks/use-data-table';
import { DataTableToolbar } from '@/components/dataTable/ToolBar';
import { useConfirmationStore } from '@/components/dialog/confirmation.store';
import { useDialogFormStore } from '@/components/dialog/form.store';
import { useDynamicLocale } from '@/hoslog-intl';
import { Pagination } from '@/react-query/context/ApiClientContextController';
import { ChargeSubcategory } from '@/services/charges/charges.types';
import { useParams, useSearch } from '@tanstack/react-router';
import React from 'react';
import { ManageChargeSubCategoryContainer } from '../ManageChargeSubCategoryContainer';
import { getColumns } from './Column';
import { useToggleSubcategoryStatus } from '../hooks/useManageSubcategory';

export function ChargeWithdrawalCategoryTable({
  data,
  pagination,
  isLoading = false,
}: {
  data: ChargeSubcategory[];
  pagination: Pagination;
  isLoading: boolean;
}) {
  const { t } = useDynamicLocale();
  const { categoryId } = useParams({ from: '/(app)/configuration-management/charges/$categoryId' });
  const { onOpen } = useDialogFormStore();
  const { openConfirmation } = useConfirmationStore();
  const { mutateAsync: toggleStatus } = useToggleSubcategoryStatus();

  const { agentType } = useSearch({ from: '/(app)/configuration-management/charges/$categoryId/' });
  const columns = React.useMemo(
    () => getColumns(onOpen, openConfirmation, t, toggleStatus, categoryId, agentType),
    [onOpen, openConfirmation, t, categoryId, toggleStatus, agentType],
  );
  const pageCount = React.useMemo(
    () => Math.ceil((pagination.totalItems ?? 0) / (pagination.pageSize ?? 1)),
    [pagination.totalItems, pagination.pageSize],
  );

  const onAddnew = () => {
    onOpen({
      title: 'Manage Commission',
      okText: t('common.page.modal.submit'),
      size: 'lg',
      modalTitle: 'configurationManagement.charges.assignChargeModal.manageCharge',
      component: <ManageChargeSubCategoryContainer categoryId={categoryId} agentType={agentType} />,
    });
  };

  const { table } = useDataTable({
    data,
    columns,
    pageCount: pageCount,
    meta: {
      title: <CrumbTitle id="configurationManagement.charges.chargeSubCategory.table.withdrawal" />,
      action: onAddnew,
      actionKey: 'onAddNew',
      totalPage: pagination.totalItems,
      loading: isLoading,
    },
    shallow: false,
    clearOnDefault: true,
  });
  return (
    <>
      <DataTable table={table}>
        <DataTableToolbar />
      </DataTable>
    </>
  );
}
